import { useMutation } from '@tanstack/react-query';

import { axios } from '@/src/lib/axios/axios';
import { generateRoutePath } from '@/src/routes';

import { QUICKBOOKS_BASE_URL } from '.';

import { Draft } from '../types/draft';

type DeleteDraftParams = {
  draftId: Draft['draftId'];
  documentId: number;
};

type DeleteTreatmentResponse = {
  draftId: Draft['draftId'];
};

const deleteDraft = ({
  draftId,
  documentId,
}: DeleteDraftParams): Promise<DeleteTreatmentResponse> => {
  const url = generateRoutePath(`${QUICKBOOKS_BASE_URL}/:documentId/drafts/:draftId`, {
    draftId,
    documentId,
  });

  return axios.delete(url);
};

export const useDeleteDraft = () => {
  return useMutation({
    mutationFn: (mutationsParams: DeleteDraftParams) => deleteDraft(mutationsParams),
  });
};
